import {useEffect, useMemo, useState, } from 'react';
import { apiEndPoints } from './remote/apiEndPoints';

const useZoneUnitPrices = (projectId) => {
  const [unitPrices, setUnitPrices] =
    useState([]);

  const [loading, setLoading] =
    useState(false);

  const [error, setError] =
    useState(null);

  useEffect(() => {
    if (!projectId) {
      setUnitPrices([]);
      setError(null);
      setLoading(false);
      return;
    }

    let mounted = true;

    // Clear the previous project's prices immediately
    setUnitPrices([]);
    setError(null);
    setLoading(true);

    const fetchPrices = async () => {
      try {
        const response =
          await apiEndPoints.getZoneUnitPrices(
            projectId
          );

        const data =
          response?.data?.data ||
          response?.data ||
          response;

        const prices =
          Array.isArray(data?.unit_prices)
            ? data.unit_prices
            : [];

        if (mounted) {
          setUnitPrices(prices);
        }
      } catch (err) {
        if (mounted) {
          setUnitPrices([]);
          setError(err);
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    fetchPrices();

    return () => {
      mounted = false;
    };
  }, [projectId]);

  const priceMap = useMemo(() => {
    return unitPrices.reduce(
      (acc, item) => {
        if (item?.resource_type) {
          acc[item.resource_type] = item;
        }

        return acc;
      },
      {}
    );
  }, [unitPrices]);

  const getUnitPrice = (
    resourceType,
    currency = 'NGN'
  ) => {
    const price =
      priceMap?.[resourceType];

    if (!price) {
      return null;
    }

    const rawPrice =
      currency === 'USD'
        ? price?.dollar_price
        : price?.naira_price;

    if (
      rawPrice === undefined ||
      rawPrice === null ||
      rawPrice === ''
    ) {
      return null;
    }

    const parsedPrice =
      Number(rawPrice);

    return Number.isFinite(parsedPrice)
      ? parsedPrice
      : null;
  };

  return {
    unitPrices,
    priceMap,
    getUnitPrice,
    loading,
    error,
  };
};

export default useZoneUnitPrices;